import {inject, IReactComponent} from 'mobx-react';
import {LeftBarComponent} from '../../../../../../../layouts/main-layout/left-bar-base/LeftBarComponent';

const mapStoresToProps = (stores: any) => ({
    controller: stores.multipartyDashboardStore.liveLeftBarController
});

export const LeftBar = inject(mapStoresToProps)(LeftBarComponent) as IReactComponent;
